import { Spin } from "antd";
import BodyList from "../../BodyList";
import HeaderList from "../../HeaderList";
import { useIntl } from "react-intl";
import Empty from "../../../common/Empty";

const PaymentSummary = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();
  console.log(data);

  const cols = [
    intl.formatMessage({ id: "paymentMethod" }), // for "PaymentMethod"
    intl.formatMessage({ id: "paymentAmount" }), // for "PaymentAmount"
    intl.formatMessage({ id: "noOfPayments" }), // for "NoOfPayments"
  ];
  return isLoading ? (
    <Spin className="flex items-center justify-center my-4" />
  ) : data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList data={data} page={page} setPage={setPage} />
    </div>
  ) : (
    <Empty title="لا توجد مبيعات" subTitle="" />
  );
};

export default PaymentSummary;
